let intro = {
    title: "Hi traveler, my name is Arthur Miranda!",
    description: "Data Engineer at Delfos | Scaling Operations through Intelligence."
};

export default intro;

